const cardList = document.querySelector('.card-list--three-col');

if (cardList) {
  const postList = document.querySelector('.post-list.card-list--three-col');
  // Get order
  const getCardListOrder = () => {
    const order = postList.querySelector('input[name="sort"]:checked');
    return order ? order.id : 'date_desc';
  };

  // Axios get paginated post list
  const axiosGetPaginatedPostList = async (page, loadMoreButton = null) => {
    const formDataInput = {
      action: 'getPaginatedPostList',
      order: getCardListOrder(),
      category: postList.dataset.category,
      fromMehler: postList.dataset.fromMehler,
      pageNumber: page.toString(),
      postCount: loadMoreButton ? postList.querySelectorAll('.card-list__item').length : 0,
    };

    try {
      const response = await axios.post(localData.siteURL, formDataInput);
      const cardListRow = postList.querySelector('.card-list__row');
      if (loadMoreButton) {
        cardListRow.insertAdjacentHTML('beforeend', response.data.data.html);
      } else {
        cardListRow.innerHTML = response.data.data.html;
      }
      postList.querySelector('.card-list__footer').innerHTML = response.data.data.html_footer;

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['order', 'pageNumber']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
    } catch (err) {
      console.error(err);
      if (loadMoreButton) {
        loadMoreButton.disabled = false;
      }
    }
  };

  // click event for dropdown items for sorting
  const dropdownItems = cardList.querySelectorAll('.post-list .card-list__header-right .dropdown__list-item input');
  dropdownItems.forEach((item) => {
    item.addEventListener('click', () => {
      const activePage = postList.querySelector('.page-numbers.is-active');
      axiosGetPaginatedPostList(activePage ? activePage.dataset.page : 1);
    });
  });

  // click load more posts
  attachEvent('.post-list .card-list__load-more', 'click', (ev) => {
    ev.preventDefault();
    ev.target.disabled = true;
    const activePage = postList.querySelector('.page-numbers.is-active');
    axiosGetPaginatedPostList(parseInt(activePage ? activePage.dataset.page : 1) + 1, ev.target);
  });

  // click event for pagination
  attachEvent('.post-list a.page-numbers:not(.is-active)', 'click', (ev) => {
    ev.preventDefault();
    postList.scrollIntoView({ block: 'start', offset: 50 });
    axiosGetPaginatedPostList(ev.target.dataset.page ?? ev.target.closest('.page-numbers').dataset.page);
  });

  const addNumber = (htmlString, numberToAdd) => {
    const regex = /\d+/g;
    const numbers = htmlString.match(regex);

    if (numbers && numbers.length >= 2) {
      const firstNumber = parseInt(numbers[0]);
      const newFirstNumber = firstNumber + numberToAdd;

      return htmlString.replace(numbers[0], newFirstNumber);
    }

    return htmlString;
  };

  const replaceNumber = (htmlString, numberToReplace) => {
    const regex = /\d+/g;
    const numbers = htmlString.match(regex);

    if (numbers && numbers.length >= 2) {
      return htmlString.replace(numbers[0], numberToReplace);
    }

    return htmlString;
  };

  const axiosLoadEvents = async (page, ev, cardList, isLoadMore) => {
    const data = {
      page,
      action: 'getLoadMoreEvents',
      isLoadMore,
    };

    try {
      const response = await axios.post(localData.siteURL, data);
      const url = new URL(window.location.href);
      const { searchParams } = url;

      if (isLoadMore) {
        cardList.querySelector('.card-list__row').insertAdjacentHTML('beforeend', response.data.html);
        cardList.querySelector('.card-list__footer-left').innerHTML = addNumber(
          cardList.querySelector('.card-list__footer-left').innerHTML,
          response.data.new_cards,
        );
        if (response.data.load_more_posts === true) {
          ev.target.disabled = false;
        }
      } else {
        cardList.scrollIntoView({ block: 'start', offset: 50 });
        cardList.querySelector('.card-list__row').innerHTML = response.data.html;
        cardList.querySelector('.card-list__footer-left').innerHTML = replaceNumber(
          cardList.querySelector('.card-list__footer-left').innerHTML,
          response.data.new_cards,
        );
        ev.target.closest('.card-list__footer').querySelector('.card-list__load-more').disabled =
          response.data.load_more_posts !== true;
      }

      cardList.querySelector('.card-list__footer-right').innerHTML = response.data.pagination;
      searchParams.set('pageNumber', page);
      url.search = searchParams.toString();
      window.history.pushState({ path: url.toString() }, '', url.toString());
      ev.target.setAttribute('data-page', parseInt(page));

      if (response.data.load_more_posts === true) {
        ev.target.disabled = false;
      }
    } catch (err) {
      ev.target.disabled = false;
      console.error(err);
    }
  };

  attachEvent('.event-list .card-list__load-more', 'click', (ev) => {
    ev.preventDefault();
    ev.target.disabled = true;
    const page = ev.target.getAttribute('data-page');
    axiosLoadEvents(parseInt(page) + 1, ev, cardList, true);
  });

  attachEvent('.event-list a.page-numbers', 'click', (ev) => {
    ev.preventDefault();
    const url = new URL(window.location.href);
    const { searchParams } = url;

    let page = parseInt(searchParams.get('pageNumber'), 10) || 1;

    function updateUrl(pageNumber) {
      searchParams.set('pageNumber', pageNumber);
      url.search = searchParams.toString();
      window.history.replaceState(null, null, url.toString());
      axiosLoadEvents(page, ev, cardList, false);
    }

    if (ev.target.classList.contains('prev') || ev.target.parentElement.classList.contains('prev')) {
      page = parseInt(page) - 1;
      updateUrl(page);
    } else if (ev.target.classList.contains('next') || ev.target.parentElement.classList.contains('next')) {
      page = parseInt(page) + 1;
      updateUrl(page);
    } else {
      page = ev.target.getAttribute('data-page');
      updateUrl(page);
    }
  });
}
